
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import Btn from "../common/Btn";
import { i18nManager } from "../../i18n";
import styles from "../../assets/style.module.css";
import { IProfileWebsite } from "../../../../../services";
import { activeMedia, isPageVisible, pagePath, splitName } from "../../helpers";

export interface HeroProps {
    basePath: string;
    website: IProfileWebsite;
}

function Hero({ website, basePath }: HeroProps) {

    const labels = i18nManager.Labels;
    const { first, last } = splitName(website.display_name);
    const image = activeMedia(website, "BANNER") ?? activeMedia(website, "HALF_BODY") ?? activeMedia(website, "PASSPORT");
    const [searchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const to = (page: string) => ({ pathname: pagePath(basePath, page), search: searchParams.toString() });

    return (<section className={styles["hero"]}>
        {image
            ? (<img className={styles["hero-img"]} src={image} alt={website.display_name} />)
            : (<div className={styles["hero-outline"]}>{last}</div>)}
        <div className={styles["hero-shade"]} />
        <div className={styles["hero-caption"]}>
            <div className={styles["container"]}>
                <div className={styles["hero-kicker"]}>{website.member.tagline || labels.official_website}</div>
                <h1 className={styles["hero-name"]}>
                    {first && (<small>{first}</small>)}
                    {last}
                </h1>
                <div className={styles["hero-cta"]}>
                    {isPageVisible(website, "SCHEDULE") && (<Btn to={to("SCHEDULE")}>{labels.home.view_matches}</Btn>)}
                    {isPageVisible(website, "GALLERY") && (<Btn variant="outline" to={to("GALLERY")}>{labels.home.view_gallery}</Btn>)}
                </div>
            </div>
        </div>
    </section>);
}

export default Hero;
